export default __webpack_public_path__ + "static/media/empoweredAnalytics.0ef39414.png";